module.exports = __webpack_public_path__ + "static/media/banner_04.ac2b283e.png";